import { AppService } from './Services/AppService';
import { appModule } from './STParticipantAppModule';
import { AppServices, Misc } from '@singularsystems/neo-core';
import { NeoReactModule } from '@singularsystems/neo-react'
import { NotificationServiceModule } from '@singularsystems/neo-notifications';

import { clientsAppModule } from 'st-clients/ClientsModule';
import { awardsAppModule } from 'st-awards/AwardsModule';
import { identityAppModule } from 'st-identity/IdentityModule';
import { transactionsAppModule } from 'st-transactions/TransactionsModule';
import { participantsAppModule } from 'st-participants/ParticipantsModule';
import { allocationManagerAppModule } from 'st-allocationmanager/AllocationManagerModule';
import { dividendsAppModule } from 'st-dividends/DividendsModule';
import { reportingModule } from 'st-reporting/ReportingModule';
import { participantsCommonModule } from 'st-common/Participants/CommonParticipantsModule';

// Global Config
Misc.Settings.progressBar.reverse = true;
Misc.Settings.bootstrap.version = 5.3;

// Modules
const appService = AppService as AppServices.AppService;

appService.registerModule(AppServices.NeoModule);
appService.registerModule(NeoReactModule);
appService.registerModule(NotificationServiceModule);
appService.registerModule(appModule);
appService.registerModule(clientsAppModule);
appService.registerModule(awardsAppModule);
appService.registerModule(identityAppModule);
appService.registerModule(transactionsAppModule);
appService.registerModule(participantsAppModule);
appService.registerModule(allocationManagerAppModule);
appService.registerModule(reportingModule);
appService.registerModule(dividendsAppModule);
appService.registerModule(participantsCommonModule);